import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import Head from '../../../components/Head';
import blNewsService from '../../../services/blNewsService';
import {
  BotaoLink,
  Col,
  Conteudo,
  Imagem,
  Row,
  Secao,
  SecaoBotaoVoltar,
  SecaoCabecalho,
  SecaoSubTitulo,
  SecaoTitulo,
  Tradutor,
  Video,
} from './styles';
import api from '../../../services/api';

const SecaoFeira = ({ idPage, ...props }) => {
  const { lang } = useParams();
  const { t } = useTranslation();
  const secaoId = t('slugs.model');
  // const { getPaginas } = blNewsService();
  const [model, setModel] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    _handleGet();
  }, []);

  const _handleGet = async () => {
    await api.get(`/blnews/${idPage}`).then((response) => {
      const dados = response.data[0];
      const dado = {
        title: '',
        content: '',
        description: '',
        image: dados.image,
        video: dados.video,
        image_description: dados.image_description,
        image_mask:
          'https://paineldoexpositor.com.br/uploads/configuration/config_682267a8b52e52_87983139.png',
      };

      if (lang !== 'pt') {
        dado.title = dados['title_' + lang];
        dado.content = dados['content_' + lang];
        dado.description = dados['description_' + lang];
        dado.image_mask =
          lang === 'es'
            ? 'https://paineldoexpositor.com.br/uploads/configuration/config_682267a8b54570_81835869.png'
            : 'https://paineldoexpositor.com.br/uploads/configuration/config_682267a8b55bd1_95684849.png';
      } else {
        dado.title = dados.title;
        dado.content = dados.content;
        dado.description = dados.description;
      }
      setModel(dado);
      setIsLoading(true);
    });
    // await getPaginas(idPage)
    //   .then(({ items }) => (items && items.length ? items[0] : {}))
    //   .then((dado) => {
    //     console.log(dado);
    //     const data = {
    //       title: '',
    //       content: '',
    //       description: '',
    //       image: dado.image,
    //       video: dado.video,
    //       image_description: dado.image_description,
    //       image_mask:
    //         'https://paineldoexpositor.com.br/uploads/configuration/config_682267a8b52e52_87983139.png',
    //     };
    //     console.log(data);
    //     if (lang !== 'pt') {
    //       data.title = dado['title_' + lang];
    //       data.content = dado['content_' + lang];
    //       data.description = dado['description_' + lang];
    //       data.image_mask =
    //         lang === 'es'
    //           ? 'https://paineldoexpositor.com.br/uploads/configuration/config_682267a8b54570_81835869.png'
    //           : 'https://paineldoexpositor.com.br/uploads/configuration/config_682267a8b55bd1_95684849.png';
    //     } else {
    //       data.title = dado.title;
    //       data.content = dado.content;
    //       data.description = dado.description;
    //     }
    //     console.log(data);
    //     setModel(data);
    //     setIsLoading(true);
    //   });
  };

  const changeHead = () => (
    <Head title={model.title} description={model.description} />
  );

  return (
    <Secao {...props} id={secaoId}>
      {isLoading ? changeHead() : null}
      <SecaoCabecalho>
        <SecaoTitulo>
          <Tradutor path={isLoading ? model.title : ''} />
        </SecaoTitulo>
        <SecaoBotaoVoltar />
      </SecaoCabecalho>
      <SecaoSubTitulo className="mb-4">
        <Tradutor path={isLoading ? model.description : ''} />
      </SecaoSubTitulo>
      <Row>
        <Col md="6">
          <Conteudo
            dangerouslySetInnerHTML={{
              __html: isLoading ? model.content : '',
            }}
          />
        </Col>
        {isLoading && (
          <Col md="6">
            {model.video ? (
              <Video
                imagemPlaceholder={isLoading ? model.image_mask : ''}
                alt={isLoading ? model.image_description : ''}
                videoEmbedded={model.video}
                showIcon={true}
              />
            ) : (
              <Imagem
                src={isLoading ? model.image_mask : ''}
                alt={isLoading ? model.image_description : ''}
              />
            )}
            <Row className="m-0">
              <Col className="pl-0">
                <BotaoLink
                  className="btn btn-primary btn-block"
                  to={`/${lang}#${t('slugs.queroVisitar')}`}
                >
                  <Tradutor path="paginas.inicial.secaoSicc.botaoQueroVisitar" />
                </BotaoLink>
              </Col>
              <Col className="pr-0">
                <BotaoLink
                  className="btn btn-primary btn-block"
                  to={`/${lang}/${t('slugs.galeriaDeImagens')}`}
                >
                  <Tradutor path="paginas.inicial.secaoSicc.botaoGaleria" />
                </BotaoLink>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </Secao>
  );
};
SecaoFeira.propTypes = {
  idPage: PropTypes.any,
};
export default SecaoFeira;
